import { FeedbackParam, GetFilteredFeedbackHistoryOutput } from '../types/backendService';

const feedbackTextPlaceholder = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.';

const positiveFeedbacks: FeedbackParam[] = [
  {
    deliveredDateUtc: 1653091200, // 5/21/2022
    enteredDateUtc: 1653091200,
    type: 'QUALITY',
    level : 'DOCUMENTED_POSITIVE',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Positive',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {},
  },
  {
    deliveredDateUtc: 1652745600, // 5/17/2022
    enteredDateUtc: 1652745600,
    type: 'PRODUCTIVITY',
    level : 'DOCUMENTED_POSITIVE',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Positive',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {},
  },
  {
    deliveredDateUtc: 1650067200, // 4/16/2022
    enteredDateUtc: 1650067200,
    type: 'PRODUCTIVITY',
    level : 'DOCUMENTED_POSITIVE',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Positive',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {},
  },
  {
    deliveredDateUtc: 1648771200, // 4/1/2022
    enteredDateUtc: 1648771200,
    type: 'QUALITY',
    level : 'DOCUMENTED_POSITIVE',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Positive',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {},
  },
];

const safetyFeedbacks: FeedbackParam[] = [
  {
    deliveredDateUtc: 1651363200, // 5/1/2022
    enteredDateUtc: 1651363200,
    type: 'SAFETY',
    level : 'FINAL_WRITTEN_WARNING',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Safety',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {},
  },
  {
    deliveredDateUtc: 1653091200, // 4/20/2022
    enteredDateUtc: 1653091200,
    type: 'SAFETY',
    level : 'FIRST_WRITTEN_WARNING',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Safety',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {},
  },
  {
    deliveredDateUtc: 1653091200, // 3/23/2022
    enteredDateUtc: 1653091200,
    type: 'SAFETY',
    level : 'DOCUMENTED_COACHING',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Safety',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {},
  },
];

const standardsFeedbacks: FeedbackParam[] = [
  {
    deliveredDateUtc: 1645315200, // 2/20/2022
    enteredDateUtc: 1645315200,
    type: 'BEHAVIORAL',
    level : 'FIRST_WRITTEN_WARNING',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Standards',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {},
  },
];

const timeFeedbacks: FeedbackParam[] = [
  {
    deliveredDateUtc: 1654041600, // 6/1/2022
    enteredDateUtc: 1654041600,
    type: 'BEHAVIORAL_ATTENDANCE',
    level : 'VERBAL_COACHING',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Time',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {},
  },
  {
    deliveredDateUtc: 1653004800, // 5/20/2022
    enteredDateUtc: 1653004800,
    type: 'ATTENDANCE',
    level : 'FIRST_WRITTEN_WARNING',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Time',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {
      unpaidPersonalTimeHours: 2.3,
      attendancePullDateUtc: 1653004800
    },
  },
];

const productivityFeedbacks: FeedbackParam[] = [
  {
    deliveredDateUtc: 1654041600, // 6/1/2022
    enteredDateUtc: 1653436800, // 5/25/2022
    type: 'PRODUCTIVITY',
    level : 'FIRST_WRITTEN_WARNING',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Productivity',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {
      dateRange: 1653436800, // 5/25/2022
    },
  },
  {
    deliveredDateUtc: 1653004800, // 5/20/2022
    enteredDateUtc: 1652400000, // 5/13/2022
    type: 'PRODUCTIVITY',
    level : 'DOCUMENTED_COACHING',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Productivity',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {
      dateRange: 1652400000, // 5/13/2022
    },
  },
];

const qualityFeedbacks: FeedbackParam[] = [
  {
    deliveredDateUtc: 1654041600, // 6/1/2022
    enteredDateUtc: 1653436800, // 5/25/2022
    type: 'QUALITY',
    level : 'FIRST_WRITTEN_WARNING',
    deliveredBy: 'dalmiaa',
    warehouseId: 'MDW7',
    feedbackCategory: 'Quality',
    areasOfImprovement: feedbackTextPlaceholder,
    incidentDetails: feedbackTextPlaceholder,
    details: {
      dateRange: 1653436800, // 5/25/2022
    },
  },
];

const feedbackMap = new Map<string, FeedbackParam[]>();
feedbackMap.set('Positive', positiveFeedbacks);
feedbackMap.set('Safety', safetyFeedbacks);
feedbackMap.set('Standards', standardsFeedbacks);
feedbackMap.set('Time', timeFeedbacks);
feedbackMap.set('Productivity', productivityFeedbacks);
feedbackMap.set('Quality', qualityFeedbacks);

export const getFeedbacksStub = (filters?: string[]): GetFilteredFeedbackHistoryOutput => {
  let feedbacks: FeedbackParam[] = [];
  if (filters == undefined) {
    for (const feedbackParams of Array.from(feedbackMap.values())) {
      feedbacks.push(...feedbackParams);
    }
  } else {
    for (const filter of filters) {
      feedbacks.push(...feedbackMap.get(filter)!);
    }
  }

  return {
    feedbackParams: feedbacks,
  };
}